<template>
  <span class="text-watermask" :style="{'color':color }"> {{ text }} </span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: () => "rgba(255, 255, 255, 0.6)",
    },
    text: {
      type: String,
      default: () => 'Powered by FoodStory CRM',
    },
  },
};
</script>

<style scoped>
.text-watermask {
    font-style: normal;
    font-weight: 400;
    bottom: 5%;
    right: 0%;
    display: flex;
    left: 0%;
    position: fixed;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
    justify-content: center;
}
</style>
